module.exports = __webpack_public_path__ + "img/495-872bba.png";